import { useQuery } from '@tanstack/react-query';
import { streamingServiceApi } from '@/services/streaming-service';

interface ServiceBadgeProps {
  icon: string;
  name: string;
  showName?: boolean;
}

export function ServiceBadge({ icon, name ,showName = true }: ServiceBadgeProps) {

  if (!icon) return null;

  return (
    <div className="flex items-center gap-2">
      <span className="text-lg" role="img" aria-label={name}>
        {icon}
      </span>
      {showName && (
        <span className="font-medium text-foreground">{name}</span>
      )}
    </div>
  );
}
